// Ползунки громкости «Звуки» + «Музыка» (кит §09) — общие для экрана настроек и
// паузы уровня. Применяются сразу: локально в prefs (PlayScreen подписан на них и
// зовёт setVolumes плеера живьём), залогиненному — ещё и PATCH /me settings-мёрж
// после «отпустил ползунок» (best-effort, patchMe сам no-op для гостя).

import type { CSSProperties } from 'react';
import { authStore } from '@/auth/authStore';
import { getPrefs, setPrefs, usePrefs } from '@/meta/prefsStore';
import { playVolumeBlip } from '@/meta/uiSfx';

function VolumeRow({ id, label, value, onChange, onCommit }: {
  id: string;
  label: string;
  value: number; // 0..1
  onChange: (v: number) => void;
  onCommit: () => void;
}) {
  const pct = Math.round(value * 100);
  return (
    <div className="slider-row">
      <div className="slider-head">
        <b>{label}</b>
        <span className="slider-val" data-testid={`${id}-value`}>{pct}%</span>
      </div>
      <input
        type="range"
        min={0}
        max={100}
        value={pct}
        // --val = заливка трека до бегунка (слайдер кита, meta.css)
        style={{ '--val': `${pct}%` } as CSSProperties}
        data-testid={`${id}-slider`}
        aria-label={`Громкость: ${label.toLowerCase()}`}
        onChange={(e) => onChange(Number(e.target.value) / 100)}
        onPointerUp={onCommit}
        onKeyUp={onCommit}
      />
    </div>
  );
}

function pushToServer() {
  const { music, sfx } = getPrefs();
  void authStore.patchMe({ settings: { music, sfx } }).catch(() => {});
}

export function VolumeControls() {
  const prefs = usePrefs();
  return (
    <>
      <VolumeRow
        id="sfx"
        label="Звуки"
        value={prefs.sfx}
        onChange={(v) => setPrefs({ sfx: v })}
        onCommit={() => {
          playVolumeBlip(getPrefs().sfx); // отпустил ползунок — услышал громкость
          pushToServer();
        }}
      />
      <VolumeRow
        id="music"
        label="Музыка"
        value={prefs.music}
        onChange={(v) => setPrefs({ music: v })}
        onCommit={pushToServer}
      />
    </>
  );
}
